import { SideMenuI } from '../../shared/interfaces/side-menu.interface';

export const SUPPORTS_SIDE_MENU_ITEMS: SideMenuI[] = [
  {
    title: 'Merchants',
    route: 'merchants',
    translationPath: 'sideMenu.merchants',
    activeIcon: 'svgs/side-menu/active-merchant-overview.svg',
    inactiveIcon: 'svgs/side-menu/inactive-merchant-overview.svg',
    roles: [],
  },
  {
    title: 'Customers',
    route: 'customers',
    translationPath: 'sideMenu.customers',
    activeIcon: 'svgs/side-menu/active-merchant-orders.svg',
    inactiveIcon: 'svgs/side-menu/inactive-merchant-orders.svg',
    roles: [],
  },
];
